import { jsx as _jsx } from "react/jsx-runtime";
import { TabPanel } from '@mui/lab';
import { Stack } from '@mui/material';
import { useContext } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
/**
 * @deprecated CRA — This component introduces poor usability (removes developer control of height) and UX (double-scrollbars) and I don't think it should exist
 *
 * Rather, use {@link TabPanel} from `@mui/lab` instead
 */
export const VScrollingTabPanel = (props) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const { children, ...others } = props;
    // We need to take `isSmallView` into account as the Content-Box (in AppMainView) changes padding
    return (_jsx(TabPanel, { sx: { padding: 0 }, ...others, children: _jsx(Stack, { sx: {
                maxHeight: (t) => `min(calc(100cqh - ${t.spacing(2)}), 100svh - ${isSmallView ? 4 : 5}rem)`,
                overflowY: 'auto',
                paddingBlockStart: 1,
            }, children: children }) }));
};
